import { KiaPage_Pagebuilder_Blocks_ColoredHero } from '@/graphql/generated/graphql';
import DOMPurify from 'dompurify';
import { m } from 'motion/react';

function ColoredHero({
  heading,
  description,
  backgroundColor,
  textColor,
  eyebrow,
}: KiaPage_Pagebuilder_Blocks_ColoredHero) {
  return (
    <section
      className="px-4 py-10 md:py-16 bg-[var(--hero-bg)] text-[var(--hero-text)]"
      style={
        {
          '--hero-bg': backgroundColor ?? '#05141F',
          '--hero-text': textColor ?? '#ffffff',
        } as React.CSSProperties
      }
    >
      <div className="max-w-screen-kia-md mx-auto">
        {eyebrow && (
          <m.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
            className="inline-block border border-current/30 px-3 py-1 text-sm mb-6"
          >
            {eyebrow}
          </m.div>
        )}
        {heading && (
          <m.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              duration: 0.6,
              delay: 0.1,
              ease: [0.16, 1, 0.3, 1],
            }}
            className="text-4xl md:text-6xl font-medium leading-tight mb-5"
          >
            {heading}
          </m.h1>
        )}
        {description && (
          <m.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              duration: 0.6,
              delay: 0.2,
              ease: [0.16, 1, 0.3, 1],
            }}
            className="text-base font-light opacity-70 leading-relaxed"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(description),
            }}
          ></m.p>
        )}
      </div>
    </section>
  );
}

export default ColoredHero;
